import React, { useEffect } from "react";
import { Page, FlexContainer, SecondaryButton } from "../components/styled";
import { shake, slideInTop, Vibrate1 } from "../components/styled/animations";
import styled, { css } from "styled-components";
// import MonsterImage from "../assets/images/monster.png";
import ProgressBar from "../components/shared/progressBar";
import GiftImage from "../assets/images/gift.png";
import CardInGameImage from "../assets/images/cardsingame.svg";
import EssenceImage from "../assets/images/essence.png";
import GameSlider from "../components/gameSlider";
import { getAirDrop,getHunterPackAirdrop } from "../service/main/api";
import { useDeck } from "../context/DeckContext";
import { useUserContext } from "../context/UserContext";
import { claimAirdrop } from "../service/main/api";
import CountdownTimer from "../components/shared/countDown";
import { useBottomSheet } from "../context/BottomSheetContext";
import RechargeModalContent from "../components/rechargeModalContent";
import { useNavigate } from "react-router-dom";
import { useUpgradeResultModal } from "../hooks/useUpgradeResultModal";
import { useAirdropModal } from "../hooks/useAirdropModal";
import { monsterAttack } from "../components/styled/animations";
import LeaderboardIcon from "../assets/icons/leaderboard.png";
import CardBackLightAnimation from "../assets/animations/card_back_light.json";
import Lottie from "lottie-react";
import HunterPackImage from "../assets/images/hunterPackImage.png";
// import LuckyPassIcon from "../assets/images/luckyPass.png";
// import CardSVG from "../assets/icons/card.png";
import { useToaster } from "../hooks/useToaster";
import { useLoading } from "../context/LoadingContext";

const Game = () => {
  const [userCards, setUserCards] = React.useState([]);
  const [airdropData, setAirdropData] = React.useState(null);
  const [hunterPackAirdropData, setHunterPackAirdropData] = React.useState(null);
  const [monsterAttackAnimation, setMonsterAttackAnimation] = React.useState(
    css`
      ${slideInTop} 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) both
    `,
  );
  const [remainingTime, setRemainingTime] = React.useState(0);
  const [monsterImage, setMonsterImage] = React.useState("");
  const [gameBacgroundImage, setGameBacgroundImage] = React.useState("");
  const [claimed, setClaimed] = React.useState(false);
  const [hunterPackClaimed, setHunterPackClaimed] = React.useState(false);
  const [hunterPackRemainingTime, setHunterPackRemainingTime] = React.useState(0);
  const { user } = useUserContext();
  const { deck } = useDeck();
  const { openSheet, closeSheet } = useBottomSheet();
  const navigate = useNavigate();
  const { openUpgradeResultModal } = useUpgradeResultModal();
  const { openAirdropModal } = useAirdropModal();
  const { showToaster } = useToaster();
  const { setIsLoading } = useLoading();
  const openRechargeSheet = () => {
    openSheet({
      content: (
        <RechargeModalContent navigate={navigate} onClose={closeSheet} />
      ),
      title: "Recharge Energy",
    });
  };
  useEffect(() => {
    if (!deck?.slots) return;

    let cards = [...deck.slots];
    if (cards.length === 0) return;
    let cardsData = cards;
    let i = 1;
    while (cardsData.length < 5) {
      if (i === cards.length - 1) {
        i = 1;
      }
      if (cards[i]?.rarity) {
        cardsData.push(cards[i]);
      } else {
        cardsData.push(cards[0]);
      }
      // cardsData.push(cards[i]);
      i++;
    }
    setUserCards(cardsData);
    const animationInterval = setInterval(() => {
      setMonsterAttackAnimation(css`
        ${monsterAttack} 0.5s linear both;
      `);
      setTimeout(() => {
        setMonsterAttackAnimation("none");
      }, 500);
    }, 2900);
    return () => clearInterval(animationInterval);
  }, [deck?.slots]);
  useEffect(() => {
    if (deck?.dungeon) {
      setMonsterImage(deck.dungeon.monsterImageUri);
      setGameBacgroundImage(deck.dungeon.backgroundImageUri);
    }
  }, [deck]);
  const handleAirdropData = async () => {
    try {
      const { data } = await getAirDrop();
      setAirdropData(data);
      const currentTimestamp = Math.floor(new Date().getTime() / 1000);
      let lastClaimedTime = user?.airdropClaimes[data._id.toString()] || 0;
      const remaining =
        data.distributionCycle - (currentTimestamp - lastClaimedTime);
      setRemainingTime(Math.floor(remaining));
      console.log("remaining", remaining);
      if (remaining <= 0) {
        setClaimed(false);
      } else {
        setClaimed(true);
      }
    } catch (error) {
      console.error("Error fetching airdrop", error);
    }
  };
  const handleHunterPackAirdropData = async () => {
    try {
      const { data } = await getHunterPackAirdrop();
      setHunterPackAirdropData(data);
      const currentTimestamp = Math.floor(new Date().getTime() / 1000);
      let lastClaimedTime = user?.airdropClaimes[data._id.toString()] || 0;
      const remaining =
        data.distributionCycle - (currentTimestamp - lastClaimedTime);
      setHunterPackRemainingTime(Math.floor(remaining));
      console.log("remaining", remaining);
      if (remaining <= 0) {
        setHunterPackClaimed(false);
      } else {
        setHunterPackClaimed(true);
      }
    } catch (error) {
      console.error("Error fetching hunter pack airdrop", error);
    }
  };
  const handleClaime = async (airdropId) => {
     if (airdropId === hunterPackAirdropData?._id && hunterPackClaimed) {
       return;
     }
     if (airdropId === airdropData?._id && claimed) {
       return;
     }
    setIsLoading(true);
    const res = await claimAirdrop({ airdropId });
    setIsLoading(false);
    if (res?.success) {
      if(airdropId === hunterPackAirdropData._id){
        setHunterPackClaimed(true);
        setHunterPackRemainingTime(hunterPackAirdropData.distributionCycle);
      }else{
        setClaimed(true);
         setRemainingTime(airdropData.distributionCycle);
      }
     
      showClaimResult(res.data);
    }else{
      showToaster({ type: "error", message: res.message });
    }
  };
  const showClaimResult = (airdrop) => {
    switch (airdrop.type) {
      case "Card":
        openUpgradeResultModal(
          { ...airdrop.card, miningPower: airdrop.card.rarity.miningPerDay },
          true,
          "Claimed Card",
        );
        break;
      default:
        openAirdropModal(airdrop);
        break;
    }
  };

  useEffect(() => {
    handleAirdropData();
    handleHunterPackAirdropData();
  }, [user]);
  return (
    <GamgePageContainer>
      <GameBacgroundImage src={gameBacgroundImage} />
      <ProgressContaner>
        <span>Energy</span>
        <ProgressBar
          progress={
            user?.energy > 0 && user?.energy < 1
              ? 0.1
              : parseFloat(user?.energy).toFixed(2)
          }
        />
        <span>
          {user?.energy > 0 && user?.energy < 1
            ? 0.1
            : parseFloat(user?.energy).toFixed(2)}
        </span>
        <RechargeButton
          onClick={
            user?.energy > 0
              ? () =>
                  showToaster({
                    type: "warning",
                    message: `You have still energy ${user?.energy}`,
                  })
              : openRechargeSheet
          }
        >
          Recharge
        </RechargeButton>
      </ProgressContaner>
      <MonsterContainer animation={monsterAttackAnimation}>
        <Monster dungeon={deck?.dungeon?.dungeonId} src={monsterImage} />
      </MonsterContainer>
      <GameActionsContainer>
        <GiftContainer claimed={claimed} onClick={() => handleClaime(airdropData._id)}>
          <div>
            {!claimed && (
              <Lottie
                style={{
                  position: "absolute",
                  width: 38,
                  height: 38,
                  transform: "scale(2.4)",
                }}
                animationData={CardBackLightAnimation}
              />
            )}
            <ShakeContainer style={claimed ? { animation: "none" } : {}}>
              <GiftImageContainer>
                <img src={GiftImage} style={{ width: "100%" }} alt="Gift" />
              </GiftImageContainer>
            </ShakeContainer>
          </div>

          {remainingTime > 0 ? (
            <CountdownTimer
              initialSeconds={remainingTime}
              onFinish={() => setClaimed(false)}
            />
          ) : (
            <span>00.00.00</span>
          )}
        </GiftContainer>
        <GiftContainer>
          <GiftImageContainer>
            <img src={EssenceImage} style={{ width: "100%" }} alt="Item" />
            <Badge>{user?.balances["69a8c43b24c993c259100749"] || 0}</Badge>
          </GiftImageContainer>
          <span style={{ fontSize: "12px", marginTop: 3 }}>Essence</span>
        </GiftContainer>

        <GiftContainer
          style={{ position: "absolute", bottom: "24vh", zIndex: 10 }}
        >
          <StyledGiftImageContainer>
            <img src={CardInGameImage} alt="Cards" />
          </StyledGiftImageContainer>
          <CardCount>{deck?.slots.length || 0}/24</CardCount>
        </GiftContainer>
      </GameActionsContainer>
      <GameActionsContainer style={{ left: "16px", right: "auto" }}>
        <GiftContainer claimed={hunterPackClaimed} onClick={() => handleClaime(hunterPackAirdropData._id)}>
          <div>
            {!hunterPackClaimed && (
              <Lottie
                style={{
                  position: "absolute",
                  width: 38,
                  height: 38,
                  transform: "scale(2.4)",
                }}
                animationData={CardBackLightAnimation}
              />
            )}
            <ShakeContainer style={hunterPackClaimed ? { animation: "none" } : {}}>
              <GiftImageContainer>
                <img src={HunterPackImage} style={{ width: "100%" }} alt="Gift" />
              </GiftImageContainer>
            </ShakeContainer>
          </div>

          {hunterPackRemainingTime > 0 ? (
            <CountdownTimer
              initialSeconds={hunterPackRemainingTime}
              onFinish={() => setHunterPackClaimed(false)}
            />
          ) : (
            <span>00.00.00</span>
          )}
        </GiftContainer>
        <GiftContainer onClick={() => navigate("/leaderboard")}>
          <GiftImageContainer>
            <img src={LeaderboardIcon} style={{ width: "100%" }} alt="Item" />
          </GiftImageContainer>
          <span style={{ fontSize: "12px" }}>Leaderboard</span>
        </GiftContainer>
        {/* <GiftContainer onClick={() => navigate("/ballcano")}>
          <GiftImageContainer>
            <img src={LuckyPassIcon} style={{ width: "100%" }} alt="Item" />
          </GiftImageContainer>
          <span style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
            Lucky Pass
          </span>
        </GiftContainer>
        <GiftContainer onClick={() => navigate("/roulette")}>
          <GiftImageContainer>
            <img width={28} src={CardSVG} alt="Item" />
          </GiftImageContainer>
          <span style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
            Roulette
          </span>
        </GiftContainer> */}
      </GameActionsContainer>
      {userCards.length > 0 && userCards[0].rarity && (
        <GameSlider cards={userCards} />
      )}
    </GamgePageContainer>
  );
};

const CardCount = styled.div`
  backdrop-filter: blur(13px);
  padding-inline: 10px;
  border-radius: 100px;
  border: 1px solid white;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: -7px;
  font-size: 8px;
  box-shadow:
    inset 0 -20px 40px rgba(0, 0, 0, 0.3),
    0 2px 0 #6e4cc9;
  background: #6939ada1;
`;
const GamgePageContainer = styled(Page)`
  width: calc(100 * var(--vw));
  height: 100vh;
  position: relative;
  overflow: hidden;
`;
const MonsterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-top: 10%;
  animation: ${(props) => props.animation};
`;
const Monster = styled.img`
  width: ${({ dungeon }) =>
    dungeon === "DG01" ? "calc(70 * var(--vw))" : "calc(60 * var(--vw))"};
  height: auto;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
`;
const ProgressContaner = styled(FlexContainer)`
  font-size: 14px;
  font-weight: 800;
  height: 44px;
  position: absolute;
  top: 17vh;
  padding: 0 16px;
  border-radius: 22px;
  background: rgba(0, 0, 0, 0.46);
  backdrop-filter: blur(30px);
  margin: 0 16px;
  width: calc(100% - 32px);
  z-index: 2;
`;
const RechargeButton = styled(SecondaryButton)`
  height: 28px;
  font-size: 12px;
`;
const GameBacgroundImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  animation: ${Vibrate1} 0.3s linear 1s 5 both;
  scale: 1.03;
`;
const GameActionsContainer = styled(FlexContainer)`
  flex-direction: column;
  width: 60px;
  height: 100%;
  position: absolute;
  right: 16px;
  top: 0;
  padding-top: 25vh;
  justify-content: flex-start;
`;
const GiftContainer = styled(FlexContainer)`
  flex-direction: column;
  font-size: 12px;
  font-weight: 600;
  gap: 4px;
  cursor: pointer;
  opacity: ${({ claimed }) => (claimed ? 0.5 : 1)};
  position: relative;
`;
const GiftImageContainer = styled(FlexContainer)`
  width: 38px;
  border-radius: 50%;
  border: 2px solid white;
  height: 38px;
  padding: 6px;
  background: #111f2e59;
  background-blend-mode: overlay;
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
  backdrop-filter: blur(13px);
`;
const Badge = styled.span`
  background-color: #6b48ac;
  position: absolute;
  border-radius: 50%;
  border: 1px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 10px;
  width: 20px;
  height: 20px;
  right: -6px;
  bottom: -6px;
`;
const StyledGiftImageContainer = styled(GiftImageContainer)`
  background: #111f2e59;
  background-blend-mode: overlay;
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
  backdrop-filter: blur(13px);
`;

const ShakeContainer = styled.div`
  animation: ${shake} 2s ease-in-out infinite;
`;
export default Game;
